// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__d9ED7","title":"FrontImage_title__1s_Bv"};